import { render, staticRenderFns } from "./SecondoComponente.vue?vue&type=template&id=f4e1a0f0&scoped=true&"
import script from "./SecondoComponente.vue?vue&type=script&lang=js&"
export * from "./SecondoComponente.vue?vue&type=script&lang=js&"
import style0 from "./SecondoComponente.vue?vue&type=style&index=0&id=f4e1a0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e1a0f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4e1a0f0')) {
      api.createRecord('f4e1a0f0', component.options)
    } else {
      api.reload('f4e1a0f0', component.options)
    }
    module.hot.accept("./SecondoComponente.vue?vue&type=template&id=f4e1a0f0&scoped=true&", function () {
      api.rerender('f4e1a0f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SecondoComponente.vue"
export default component.exports